import { Entity } from "@hds/entity-lib";

class ItemBiddingEntity extends Entity {
    static DEFAULT_DOCUMENT = {
        increment: 100,
        processedEntries: [],
        activeBidders: [],
        proxyBids: []
    };
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...ItemBiddingEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get activeBidders() {
        return this._virtualDataModel.getProperty('activeBidders');
    }
    set activeBidders(newActiveBidders) {
        return this._virtualDataModel.setProperty('activeBidders', newActiveBidders);
    }
    get badge() {
        return this._virtualDataModel.getProperty('badge');
    }
    set badge(newBadge) {
        return this._virtualDataModel.setProperty('badge', newBadge);
    }
    get bid() {
        return this._virtualDataModel.getProperty('bid');
    }
    set bid(newBid) {
        return this._virtualDataModel.setProperty('bid', newBid);
    }
    get bidType() {
        return this._virtualDataModel.getProperty('bidType');
    }
    set bidType(newBidType) {
        return this._virtualDataModel.setProperty('bidType', newBidType);
    }
    get buyNowAmount() {
        return this._virtualDataModel.getProperty('buyNowAmount');
    }
    set buyNowAmount(newBuyNowAmount) {
        return this._virtualDataModel.setProperty('buyNowAmount', newBuyNowAmount);
    }
    get buyNowDisableThreshold() {
        return this._virtualDataModel.getProperty('buyNowAmount');
    }
    set buyNowDisableThreshold(newBuyNowDisableThreshold) {
        return this._virtualDataModel.setProperty('buyNowDisableThreshold', newBuyNowDisableThreshold);
    }
    get estimatedTime() {
        return this._virtualDataModel.getProperty('estimatedTime');
    }
    set estimatedTime(newEstimatedTime) {
        return this._virtualDataModel.setProperty('estimatedTime', newEstimatedTime);
    }
    get eventDetailId() {
        return this._virtualDataModel.getProperty('eventDetailId');
    }
    set eventDetailId(newEventDetailId) {
        return this._virtualDataModel.setProperty('eventDetailId', newEventDetailId);
    }
    get expectedFinalizationStatus() {
        return this._virtualDataModel.getProperty('expectedFinalizationStatus');
    }
    set expectedFinalizationStatus(newExpectedFinalizationStatus) {
        return this._virtualDataModel.setProperty('expectedFinalizationStatus', newExpectedFinalizationStatus);
    }
    get increment() {
        return this._virtualDataModel.getProperty('increment');
    }
    set increment(newIncrement) {
        return this._virtualDataModel.setProperty('increment', newIncrement);
    }
    get lastUpdatedRawEntryId() {
        return this._virtualDataModel.getProperty('lastUpdatedRawEntryId');
    }
    get paused() {
        return this._virtualDataModel.getProperty('paused');
    }
    set paused(newPaused) {
        return this._virtualDataModel.setProperty('paused', newPaused);
    }
    get processedEntries() {
        return this._virtualDataModel.getProperty('processedEntries');
    }
    get proxyBids() {
        return this._virtualDataModel.getProperty('proxyBids');
    }
    set proxyBids(newProxyBids) {
        return this._virtualDataModel.setProperty('proxyBids', newProxyBids);
    }
    get status() {
        return this._virtualDataModel.getProperty('status');
    }
    set status(newStatus) {
        return this._virtualDataModel.setProperty('status', newStatus);
    }
    appendEntry(newProcessedItemBiddingActivity) {
        if (!this._virtualDataModel.hasProperty('processedEntries')) {
            this._virtualDataModel.setProperty('processedEntries', []);
        }
        this.processedEntries.push(newProcessedItemBiddingActivity);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}

//META PROPERTIES
Object.defineProperty(ItemBiddingEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'item-bidding'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { ItemBiddingEntity };
export default ItemBiddingEntity;